import ValPro from "./Valpro";

export default ValPro;